let order = require('../../../actions/order');
let { calcPriceGroup } = require('./price');
let customOrder = require('../../../actions/custom-order');
let currentOrder = require('../../../actions/account/current-order');
let price = require('../../../actions/order/price');
let content = require('../../../actions/layout/content');
let utils = require('../../../actions/utils');
let error = require('../../../actions/error');
let { setOrderParametersGroup, getAvailableParametersGroup } = require('../custom-order');
let { restoreStateGroup } = require('../custom-order/index');

module.exports = {
    calcPriceGroup,

    setMapFilter: [
        utils.setFromArgsToState('mapFilter', ['order', 'cities', 'mapFilter']),
        ...calcPriceGroup
    ],

    initSelectedParamsFromLocalStorageGroup: [
        [
            utils.getItemFromLocalStorage('selected_params', 'selectedParameters'),
            {
                success: [
                    ...restoreStateGroup,
                    currentOrder.updateOrder(['selectedParameters']),
                    content.setIsLoading(false),
                    ...calcPriceGroup,
                    customOrder.unsetFilterValuesChanged,
                ],
                notExists: [
                    // отметить минимальный дефолтный набор, если надо
                    // отметить город пользователя, если указан в профиле
                ],
                unavailable: [
                    // на сервере localStorage недоступен
                ]
            }
        ]
    ],

    startRestoringSelectedParams: [
        [
            order.getDraftOrder,
            {
                success: [
                    ...setOrderParametersGroup,
                    order.setShouldRestoreFromLocalStorage(false),
                    ...restoreStateGroup,
                    price.setPrice,
                    utils.setFromArgsToState('id', ['order', 'draft', 'id']),
                    utils.setFromArgsToState('isNeedToConfirmDataChanged', ['order', 'draft',
                        'isNeedToConfirmDataChanged'])
                ],
                error: [
                    // TODO раздельно обрабатывать разные коды ошибок
                    ...getAvailableParametersGroup,
                    order.setShouldRestoreFromLocalStorage(true),
                    price.setIsLoading(true),
                    content.setIsLoading(true)
                ]
            }
        ],
        customOrder.setComputedFields
    ],

    resetDraftGroup: [
        order.removeSavedSelectedParams,
        ...restoreStateGroup,
        [
            order.hasDraftOrderLoaded,
            {
                yes: [
                    [
                        order.archiveOrder,
                        {
                            success: [],
                            error: [
                                error.internalError('order.archiveOrder')
                            ]
                        }
                    ]
                ],
                no: []
            }
        ],
        ...calcPriceGroup
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/order/index.js